import { render, staticRenderFns } from "./BoostModal.vue?vue&type=template&id=271dae0a&scoped=true&lang=pug&"
import script from "./BoostModal.vue?vue&type=script&lang=js&"
export * from "./BoostModal.vue?vue&type=script&lang=js&"
import style0 from "./BoostModal.vue?vue&type=style&index=0&id=271dae0a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271dae0a",
  null
  
)

export default component.exports